<script lang="ts">
	interface Props {
		img: string
	}

	let { img }: Props = $props()
</script>

<div class="snapshot-preview-container transparent-bg">
	{#if img}
		<img src={img} alt="modified snapshot" />
	{/if}
</div>

<style>
	.snapshot-preview-container {
		pointer-events: none;
		position: absolute;
		height: 100%;
		width: 100%;
		top: 0;
		left: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.snapshot-preview-container:not(:has(img)) {
		background-image: unset;
	}
</style>
